import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import { getModule} from 'vuex-module-decorators';
import axios, {AxiosPromise}  from 'axios';
import User from "@/module/store/user";
import {CONFIG_ENV} from '@/config';
import {I_Gift} from "@/types/iGift";

interface I_AjaxResponse_SaveGift{
    status:number,
    statusText:string,
    data: {
        status:string,
        message:string,
        giftid:number
    }
}

interface I_AjaxResponse_GetGift{
    status:number,
        statusText:string,
        data: {
        status:string,
            message:string,
            gift:I_Gift
    }
}

interface I_AjaxResponse_GetDetailsFromUrlWithCurl {
    status:number,
    statusText:string,
    data: {
        status:string,
        message:string,
        gift_price:number,
        gift_description:string,
        gift_img_as_str:string
    }
}

@Component({components:{}})
export default class EditGiftForList extends Vue {
    @Prop() listid!: number;
    @Prop() list_name!: string;
    @Prop() childid!:number;
    @Prop() is_a_sugestion!:boolean;

    myBoolFalse:boolean=false;
    loadingAjax:boolean=false;
    loadingGiftDetailsFromCurl:boolean=false;
    myFiles:Array<any>=[];
    gift:I_Gift ={
        listid:0,
        giftid:0,
        userid:0,
        gift_name:'',
        gift_quantity:1,
        gift_description:'',
        gift_price:0,
        gift_currency:'RON',
        gift_url_host:'',
        gift_url_image:'',
        gift_imageid:0,
        status:'',
        img_as_str:''
    };

    fileForUpload:any;

    $refs:any;
    private userStore=getModule(User);

    constructor(){
        super();
    }

    async getDetailsFromUrlWithCurl(purl:string){
        const vueInst=this;
        var params = new URLSearchParams();
        params.append('url', purl);
        let res = await <Promise<I_AjaxResponse_GetDetailsFromUrlWithCurl>> axios.post(`${CONFIG_ENV.URL_GIFTS.get_gift_details_from_curl}`,params);
        return res;
    }

    tryToReadLinkFromClipboard(){
        const vueInst=this;
        navigator.clipboard.readText()
            .then(ptext => {
                // `text` contains the text read from the clipboard
                if(ptext.includes("http") || ptext.includes("www")){
                    vueInst.gift.gift_url_host=ptext;
                    vueInst.loadingGiftDetailsFromCurl=true;
                    vueInst.tryToGetDetailsFromLink(vueInst.gift.gift_url_host);
                }
            })
            .catch(err => {
                // maybe user didn't grant access to read from clipboard
                console.log('Something went wrong', err);
            });
    }

    tryToGetDetailsFromLink(p_url:string){
        const vueInst=this;
        vueInst.getDetailsFromUrlWithCurl(p_url).then((response:I_AjaxResponse_GetDetailsFromUrlWithCurl)=>{
            vueInst.loadingGiftDetailsFromCurl=false;
            if(response.data.status=='success'){
                if(response.data.gift_img_as_str && response.data.gift_img_as_str.length>100){
                    vueInst.gift.img_as_str=response.data.gift_img_as_str;
                }
                if(response.data.gift_description && response.data.gift_description.length>1){
                    vueInst.gift.gift_description=response.data.gift_description;
                    vueInst.gift.gift_name=response.data.gift_description;
                }
                if(response.data.gift_price && response.data.gift_price.toString().length>1){
                    vueInst.gift.gift_price=response.data.gift_price;
                }
            }
        });
    }

    async getGiftFromDB(plistid:number,pgiftid:number){
       // console.log('start getGiftFromDB plistid=%o and pgiftid=%o',plistid,pgiftid)
        const vueInst=this;
        let res = await <Promise<I_AjaxResponse_GetGift>> axios.get(`${CONFIG_ENV.URL_PUBLIC_INFO.get_gift}/${plistid}/${pgiftid}`);
        return res;
    }
    async saveGift(pgift:I_Gift){
        const vueInst=this;
        //vueInst.gift.files=vueInst.$refs.pond.getFile();
        if(pgift.giftid*1==0){
            var res = await <Promise<I_AjaxResponse_SaveGift>> axios.post(`${CONFIG_ENV.URL_GIFTS.new_gift_to_list}`,pgift);
        }
        else{
            var res = await <Promise<I_AjaxResponse_SaveGift>> axios.post(`${CONFIG_ENV.URL_GIFTS.update_gift_in_list}/${vueInst.listid}/${pgift.giftid}`,pgift);
        }
        return res;
    }

    uploadImg(){
        this.fileForUpload.upload();
    }

    tryToRenderImage2(file:any){
        var vueInst=this;
        const width = 300;
        const fileName ='test';
        const reader = new FileReader();
        reader.readAsDataURL(file.target.files[0]);
        reader.onload = (event:any) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                const elem = document.createElement('canvas');
                elem.width = width;
                const scaleFactor = width / img.width;
                elem.height = img.height * scaleFactor;

                const ctx = elem.getContext('2d') as any;
                if(ctx){
                    ctx.drawImage(img, 0, 0, elem.width, elem.height);
                    vueInst.gift.img_as_str = ctx.canvas.toDataURL(img, 'image/jpeg', 1);
                    //var d = ctx.canvas.toDataURL('image/png');
                }

            },
                reader.onerror = error => console.log(error);
        };

    }

    removeImage(){
        this.gift.img_as_str='';
    }

    renderImage(file:any){
        const vueInst=this;
        var fileHTML    = document.querySelector('input[type=file]') as any;
        if(fileHTML){
            var file_input=fileHTML.files[0]
        }


       // console.log('in renderImage, file_input=%o si gata!',file_input);


        var reader  = new FileReader();

        reader.onloadend = function () {
/*
            var img = document.createElement("img");
            img.src = reader.result as any;

            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext("2d")!;
            ctx.drawImage(img, 0, 0);

            var MAX_WIDTH = 400;
            var MAX_HEIGHT = 400;
            var width = img.width;
            var height = img.height;

            if (width > height) {
                if (width > MAX_WIDTH) {
                    height *= MAX_WIDTH / width;
                    width = MAX_WIDTH;
                }
            } else {
                if (height > MAX_HEIGHT) {
                    width *= MAX_HEIGHT / height;
                    height = MAX_HEIGHT;
                }
            }
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);

            vueInst.gift.img_as_str = canvas.toDataURL(file.type);
*/
            vueInst.gift.img_as_str= reader.result as any;
        }

        if (file_input) {
            reader.readAsDataURL(file_input);
        } else {
            vueInst.gift.img_as_str = "";
        }


    }

    tryToRenderImage(input:any) {
        //grab the first image in the fileList
        //in this example we are only loading one file.
        this.renderImage(input.target.files[0])
    }

    onReset(){
        const vueInst=this;
        vueInst.gift={
            listid:vueInst.listid,
            giftid:0,
            userid:0,
            gift_name:'',
            gift_quantity:1,
            gift_description:'',
            gift_price:0,
            gift_currency:'RON',
            gift_url_host:'',
            gift_url_image:'',
            gift_imageid:0,
            status:'',
            img_as_str:'',
        };
    }

    onSubmit(){
        const vueInst=this;
        vueInst.$q.loading.show();
        vueInst.saveGift(vueInst.gift).then(response=>{
            if(response.data.status=='success'){
                //vueInst.$emit('infofromchildCommand', 'GIFT_SAVED');
                //@ts-ignore;
                vueInst.$eventHub.$emit('infofromchildCommand','GIFT_SAVED');
            }else{
                vueInst.$q.notify({
                    color: 'red',
                    textColor: 'white',
                    position:'top-right',
                    timeout: 3000,
                    icon: 'fas fa-exclamation-triangle',
                    message: response.data.message
                });
            }
        });
    }

    mounted(){
        const vueInst=this;
        vueInst.gift.listid=vueInst.listid;
        if(vueInst.listid && vueInst.listid*1>0 && vueInst.childid && vueInst.childid*1!=0){
            vueInst.loadingAjax=true;
            vueInst.getGiftFromDB((vueInst.is_a_sugestion?0:vueInst.listid),vueInst.childid).then((response:I_AjaxResponse_GetGift)=>{
                vueInst.loadingAjax=false;
                if(response.data.status=="success"){
                   vueInst.gift={
                        listid:vueInst.listid,
                        giftid:(vueInst.is_a_sugestion?0:vueInst.childid),
                        userid:0,
                        gift_name:response.data.gift.gift_name,
                        gift_quantity:response.data.gift.gift_quantity,
                        gift_description:response.data.gift.gift_description,
                        gift_price:response.data.gift.gift_price,
                        gift_currency:response.data.gift.gift_currency,
                        gift_url_host:response.data.gift.gift_url_host,
                        gift_url_image:response.data.gift.gift_url_image,
                        gift_imageid:0,
                        status:response.data.gift.status,
                        img_as_str:response.data.gift.img_as_str,
                    }
                }
            });
        }
    }
}
